import { defaultStringifySearch, redirect } from '@tanstack/react-router'
import type { z } from 'zod'
import { createListQueryStore } from '@/stores/list-query-store.ts'

export function createListQueryPersistence<T extends { current: number; pageSize: number }>(
  name: string,
  schema: z.ZodType<T>
) {
  const store = createListQueryStore(name, schema)
  const validateSearch = (raw: Record<string, unknown>): Partial<T> => {
    const parsed = schema.parse(raw)
    // 只返回 URL 显式提供的字段，避免 Router 自动补默认值后无法识别菜单入口。
    return Object.fromEntries(Object.entries(parsed).filter(([key]) => Object.hasOwn(raw, key))) as Partial<T>
  }
  return {
    schema,
    store,
    validateSearch,
    restore: ({
      context,
      search,
      location,
      preload
    }: {
      context: { currentSession: { id: number } }
      search: Partial<T>
      location: { pathname: string; hash: string }
      preload: boolean
    }) => {
      if (preload || Object.keys(search).length) {
        return
      }
      const remembered = store.getState().searches[context.currentSession.id] ?? schema.parse({})
      // 使用 Router 自带的序列化，保留数组、布尔值和 hash。
      throw redirect({
        href: `${location.pathname}${defaultStringifySearch(remembered)}${location.hash ? `#${location.hash}` : ''}`,
        replace: true
      })
    }
  }
}
